module.exports = __webpack_public_path__ + "static/media/classic1.78600497.jpg";